import Cookies from 'js-cookie'

export function setPublicationShowPageFontSize (value) {
  Cookies.set('publication_show_page_font_size', value)
}

export function getPublicationShowPageFontSize () {
  return Cookies.get('publication_show_page_font_size') === 'true'
}
